import type { AppContextEntry } from '../../chat-app-context'
import { describeEntity } from '../../chat-app-context'

export interface DocTemplatesAppContextInput {
  /** Loaded row for the open template path, when one is open. */
  item?: { name: string; path: string; id: string }
  /** Selected folder path; mutually exclusive with an open file. */
  folder?: string
}

/**
 * The URL carries the path; the page has the row, so it offers name + path +
 * id and supersedes the raw route/search params.
 */
export function buildDocTemplateAppContextEntries(
  input: DocTemplatesAppContextInput
): AppContextEntry[] {
  const entries: AppContextEntry[] = [{ key: 'View', value: 'templates' }]

  if (input.item !== undefined) {
    entries.push({
      key: 'Open file',
      value: describeEntity({
        name: input.item.name,
        fields: [['path', input.item.path]],
        id: input.item.id
      })
    })
  }

  if (input.folder !== undefined && input.folder !== '') {
    entries.push({ key: 'Folder', value: input.folder })
  }

  return entries
}

/**
 * Baseline path/search params the entries above stand in for.
 * `*` is the resource-path splat from `/documents/templates/…` route matches.
 */
export const DOC_TEMPLATES_SUPERSEDED_PARAMS = ['view', 'file', 'folder', '*']
